<template>
  <div>
    <SlideStartDownload @closePopup="$emit('closePopup')" />
    <div v-if="positions">
      <bim-text type=main bold class="my-9 text-center">Мы также подготовили для вас полный отчет</bim-text>
      <BlockFullPositions @downloadFull="$emit('downloadFull')" :positions="positions" />
    </div>
  </div>
</template>

<script>
import SlideStartDownload from "./SlideStartDownload"
import BlockFullPositions from "./BlockFullPositions"
export default {
  name: "SlideStartDownloadExample",
  props: {
    positions: Object
  },
  components: {
    SlideStartDownload,
    BlockFullPositions,
  },
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>
